import { Capacitor } from "@capacitor/core";

export default class Logger {
  static inDebugMode(): boolean {
    // Capacitor serves the native app from localhost -- that's production, not
    // debug. Without this guard every native install is treated as debug and
    // analytics (posthog.capture) is silently suppressed.
    if (Capacitor.isNativePlatform()) return false;
    const currentUrl = window.location.href;
    return (
      currentUrl.includes("localhost") ||
      currentUrl.includes("test.") ||
      currentUrl.includes("demo.")
    );
  }

  private static timestamp(): string {
    const d = new Date();
    const pad = (n: number, w = 2) => String(n).padStart(w, "0");
    return `[${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(
      d.getSeconds()
    )}.${pad(d.getMilliseconds(), 3)}]`;
  }

  static debug(msg: unknown, ...args: unknown[]): void {
    if (Logger.inDebugMode()) {
      // Only string-interpolate strings; objects would stringify to
      // "[object Object]", so hand them to console.log as real args.
      if (typeof msg === "string") {
        console.log(`${Logger.timestamp()} ${msg}`, ...args);
      } else {
        console.log(Logger.timestamp(), msg, ...args);
      }
    }
  }

  static transparency(msg: string, ...args: unknown[]): void {
    console.log(`${Logger.timestamp()} ${msg}`, ...args);
  }

  static warn(msg: string, ...args: unknown[]): void {
    console.warn(`${Logger.timestamp()} ${msg}`, ...args);
  }

  static error(msg: string, ...args: unknown[]): void {
    console.error(`${Logger.timestamp()} ${msg}`, ...args);
  }
}
